<template>
  <div class="relative w-full flex flex-col" ref="wrapper">
    <div v-if="configDashboard" class="flex items-center justify-between absolute z-10 p-6 w-full">
      <h4 class="mb-1">Profile Card</h4>
      <vs-chip transparent color="#FBA727" class="text-base text-center cursor-pointer"
        @click.native="removeProfileCard">
        Remove
      </vs-chip>
    </div>
    <vx-card v-if="userData" class="org-card">
      <div class="" :class="configDashboard ? 'opacity' : ''">
        <div class="flex justify-between">
          <div class="flex items-center">
            <vs-avatar v-if="userData.profilePictureUrl" size="50px" :src="constants.s3Bucket +
              '/editor/profile-pictures/' +
              userData.profilePictureUrl
              " />
            <vs-avatar v-else size="50px" :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
              userData.firstName || 'boringAvatar',
              userData.lastName || 'boringAvatar'
            )}`" />
            <div class="text-left ml-1">
              <h3 class="mb-1">
                {{ userData.firstName }} {{ userData.lastName }}
              </h3>
              <p>{{ userData.email }}</p>
            </div>
          </div>
        </div>
        <hr class="my-4" style="clear: both; border-top: #f4f6fb" />
        <div class="flex flex-row flex-wrap">
          <div class="flex flex-row profile__card__balance w-100" v-for="(tokens, index) in userTokens"
            :key="index + tokens.label" v-show="tokens.label !== 'XP' &&
              tokens.label !== 'Knowledge' &&
              tokens.label !== 'Key'
              ">
            <div class="flex flex-row mr-2" v-if="
              tokens.label !== 'XP' &&
              tokens.label !== 'Knowledge' &&
              tokens.label !== 'Key'
            ">
              <div class="xp profile__card__balance__item relative mr-4" v-for="(gold, index) in tokens.tokens"
                :key="index" v-show="tokens.label === 'Gold'">
                <img :id="`${gold.organizationId.slice(-5)}-final-reward-gold`"
                  src="@/assets/images/icons/tokens/gold-coin.svg" alt="gold" class="" />
                <div class="absolute z-10 rounded-full overflow-hidden" :style="{
                  bottom: '10px',
                  left: '25px',
                  width: '25px',
                  height: '25px',
                }">
                  <img class="absolute object-cover border-0 p-0 w-full h-full"
                    :src="`${constants.s3Bucket}/organization/logo/${gold.organizationData.logo}`"
                    @error="randomFeedImage" :alt="gold.organizationData.name" />
                </div>
                <h6>{{ gold.tokenValueSum }}</h6>
              </div>

              <div class="xp profile__card__balance__item relative mr-4" v-for="(gold, index) in tokens.tokens"
                :key="index" v-show="tokens.label === 'Digital Tokens'">
                <img id="final-reward-digitalTokens" src="@/assets/images/icons/tokens/digital-token.svg" alt="gold"
                  class="" />

                <div class="absolute z-10 rounded-full overflow-hidden" :style="{
                  bottom: '17px',
                  left: '19px',
                  width: '25px',
                  height: '25px',
                }">
                  <img class="absolute object-cover border-0 p-0 w-full h-full"
                    :src="`${constants.s3Bucket}/organization/logo/${gold.organizationData.logo}`"
                    @error="randomFeedImage" :alt="gold.organizationData.name" />
                </div>
                <h6>{{ gold.tokenValueSum }}</h6>
              </div>
            </div>
          </div>
        </div>

        <div v-if="expertInData && expertInData.length" class="items-left expert-in">
          <h6 class="mb-3" style="color: #91919f !important">Expert In</h6>
          <span v-for="(skill, index) in expertInData" :key="index" class="right-panel--item-skill m-1 ml-0">
            {{ skill.title }}
          </span>
        </div>
        <div v-if="knownAsData && knownAsData.length" class="mt-6 items-left known-as" style="clear: both">
          <h6 class="mb-3" style="color: #91919f !important">Known For</h6>
          <span v-for="(personalityTrait, index) in knownAsData" :key="index"
            class="right-panel--item-personality m-1 ml-0">
            {{ personalityTrait.id != null ? 
              getPersonalityTraitById(personalityTrait.id) !== undefined ?
              getPersonalityTraitById(personalityTrait.id).ability : "" :
              personalityTrait.ability
            }}
          </span>
        </div>
        <!-- <hr
        v-if="currentlyDevelopingData && currentlyDevelopingData.length"
        class="my-base text-light"
        style="clear: both; border-top: #f4f6fb"
      />
      <div
        v-if="currentlyDevelopingData && currentlyDevelopingData.length"
        class="my-base items-left currently-developing"
        style="clear: both"
      >
        <h6 class="mb-3" style="color: #91919f !important">
          Currently Developing
        </h6>
        <span
          v-for="(data, index) in currentlyDevelopingData"
          :key="index"
          class="right-panel--item-currently-developing m-1 ml-0"
        >
          {{ data.title || getPersonalityTraitById(data.id).title }}
        </span>
      </div>
      <hr class="my-base text-light" style="clear: both; border-top: #f4f6fb" /> -->
      </div>
    </vx-card>
  </div>
</template>

<script>
import constants from "@/constants";
// import Notification from "./Notification";
import organizationConfig from "@/assets/data/organization-config.js";
import rewardsAndTokenConfig from "@/assets/data/rewardsAndTokenConfig.js";

export default {
  data() {
    return {
      constants,
      organizationConfig,
      editProfileCard: false,
      gold: 0,
      key: 0,
    };
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    authUserData() {
      return this.$store.state.auth.user;
    },
    userWidgets() {
      return this.$store.state.dashboard.userWidgets;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
    locale() {
      return this.$i18n.locale;
    },
    personalityData() {
      if (
        this.userOrganizations &&
        this.userOrganizations[0].organizationData.slug === "gala"
      )
        return this.organizationConfig["gala"].personalityTraits[this.locale];
      else
        return this.organizationConfig["default"].personalityTraits[
          this.locale
        ];
    },
    currentlyDevelopingData() {
      let cd = [];
      if (
        this.userData &&
        this.userData.extraCurricular &&
        this.userData.extraCurricular[0] &&
        this.userData.extraCurricular[0].skills &&
        this.userData.extraCurricular[0].skills.length &&
        this.userData.extraCurricular[0].skills.findIndex((skill) => {
          return Boolean(skill.activateLearning) === true;
        }) !== -1
      ) {
        cd = this.userData.extraCurricular[0].skills.filter((skill) => {
          return Boolean(skill.activateLearning) === true;
        });
      }
      if (
        this.userData &&
        this.userData.personality &&
        this.userData.personality[0] &&
        this.userData.personality[0].personalityTraits &&
        this.userData.personality[0].personalityTraits.length
      ) {
        // console.log(
        //   this.userData.personality[0].personalityTraits.filter((p) => {
        //     return p.priorityNumber !== null && p.priorityNumber !== undefined;
        //   })
        // );
        cd = [
          ...cd,
          ...this.userData.personality[0].personalityTraits.filter((p) => {
            return p.priorityNumber !== null && p.priorityNumber !== undefined;
          }),
        ];
      }
      //console.log(cd);
      if (cd.length > 0) return cd;
      return null;
    },
    expertInData() {
      if (
        this.userData &&
        this.userData.extraCurricular &&
        this.userData.extraCurricular[0] &&
        this.userData.extraCurricular[0].skills &&
        this.userData.extraCurricular[0].skills.length
      ) {
        return this.userData.extraCurricular[0].skills.filter((skill) => {
          return skill.level === 5;
        });
      }
      return null;
    },
    knownAsData() {
      if (
        this.userOrganizations &&
        this.userOrganizations[0] &&
        this.userOrganizations[0].organizationData.slug === "gala"
      ) {
        return this.galaAbilities.slice(0, 6);
      } else if (
        this.userData &&
        this.userData.personality &&
        this.userData.personality[0] &&
        this.userData.personality[0].personalityTraits &&
        this.userData.personality[0].personalityTraits.length
      ) {
        return this.userData.personality[0].personalityTraits.slice(0, 6);
      }
      return null;
    },
    configDashboard() {
      return this.$store.state.dashboard.configDashboard;
    },
    userOrganizations() {
      return this.$store.state.users.userOrganizations;
    },
    galaAbilities() {
      return this.$store.state.users.galaAbilities;
    },
    isAnimationTrue() {
      return this.$store.state.animation.isAnimationTrue;
    },
    userTokens() {
      return this.$store.state.users.userTokens;
    },
    goldId() {
      return this.$store.state.animation.goldId;
    },
  },
  watch: {
    isAnimationTrue: {
      handler(newVal) {
        if (this.goldId) {
          const fp = document
            .getElementById(`${this.goldId}-final-reward-gold`)
            .getBoundingClientRect();
          this.$store.commit("animation/SET_FINAL_POSITION_FOR_GOLD", {
            top: fp.top,
            bottom: fp.bottom,
            left: fp.left,
            right: fp.right,
          });
        }

        setTimeout(() => {
          return (this.userXP =
            this.userXP + this.userData.xp ? this.userData.xp : 0);
        }, 6500);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.fetchUserTokens(this.authUserData._id);
  },
  created() {
    this.fetchUserTokens(this.authUserData._id);
  },
  methods: {
    getPersonalityTraitById(id) {
      if (id) {
        // console.log(id);
        const p = this.personalityData.find((pd) => {
          return pd.id === id || pd.personalityMapId - 36 === id;
        });
        // console.log(p);
        return p;
      }
      return {};
    },
    removeProfileCard() {
      const profileCard = this.userWidgets.find(
        (item) => item.widgetId === "PROFILE_CARD"
      );
      this.$store
        .dispatch("dashboard/removeWidget", profileCard)
        .then((res) => {
          for (var i = 0; i < this.userWidgets.length; i++) {
            if (this.userWidgets[i].widgetId === "PROFILE_CARD") {
              this.$store.commit("dashboard/REMOVE_WIDGET", i);
            }
          }
          this.$store.commit("dashboard/SHOW_PROFILE_CARD", false);
        })
        .catch((err) => {
          throw err;
        });
    },
    // getUserGold(tokens) {
    //   if (tokens) {
    //     // 2 is for key
    //     const keyObj = tokens.find((obj) => obj.key === 2);
    //     if (keyObj) {
    //       this.key = keyObj.value;
    //     }
    //     // 6 is for gold
    //     const goldObj = tokens.find((obj) => obj.key === 6);
    //     if (goldObj) {
    //       this.gold = goldObj.value;
    //     }
    //   }
    // },
    fetchUserTokens(id) {
      if (id && this.userTokens.length === 0) {
        const payload = {
          userId: id,
        };
        this.$store
          .dispatch("users/getUserOrgTokens", payload)
          .then((res) => {
            if (res && res.data && res.data.length > 0) {
              res.data.forEach((res) => {
                res.tokens.forEach((token) => {
                  const value = res.organizationConfigurationData.values.find(
                    (value) => value.key === token.tokenKey
                  );
                  if (value) {
                    token.organizationId = res.organizationId;
                    token.organizationData = res.organizationData;
                    token.label = value.label;
                  }
                });
              });

              const organizedTokensArray = [];
              res.data.forEach((val) => {
                val.tokens.forEach((token) => {
                  const index = organizedTokensArray.findIndex(
                    (item) => item.label === token.label
                  );
                  if (index === -1) {
                    if (token.tokenValueSum > 0) {
                      organizedTokensArray.push({
                        label: token.label,
                        tokens: [
                          {
                            userId: val.userId,
                            organizationId: val.organizationId,
                            organizationData: val.organizationData,
                            tokenKey: token.tokenKey,
                            tokenValueSum: token.tokenValueSum,
                          },
                        ],
                      });
                    }
                  } else {
                    if (token.tokenValueSum > 0) {
                      organizedTokensArray[index].tokens.push({
                        userId: val.userId,
                        organizationId: val.organizationId,
                        organizationData: val.organizationData,
                        tokenKey: token.tokenKey,
                        tokenValueSum: token.tokenValueSum,
                      });
                    }
                  }
                });
              });

              this.$store.commit("users/SET_USER_TOKENS", organizedTokensArray);
            }
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    randomFeedImage(e) {
      let i = 15; // i = number of given random images
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[
        Math.floor(Math.random() * i),
      ]}.png`));
    },
    // async getOrgLogo(orgId) {
    //   try {
    //     const res = await this.$store.dispatch(
    //       "users/fetchOrganizationById",
    //       orgId
    //     );
    //     if (res && res.logo) {
    //       return `${constants.s3Bucket}/organization/logo/${res.logo}`;
    //     }
    //     return null;
    //   } catch (error) {
    //     console.error("Error during getOrgLogo:", error);
    //     throw error;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.right-panel--item-skill {
  background: rgba(68, 204, 136, 0.1);
  border-radius: 1000px;
  color: #44cc88;
  padding: 1px 12px;
  line-height: 2;
  float: left;
  font-size: 12px;
}

.right-panel--item-personality {
  background: rgba(85, 133, 255, 0.1);
  border-radius: 1000px;
  color: #5585ff;
  padding: 1px 12px;
  line-height: 2;
  float: left;
  font-size: 12px;
}

.right-panel--item-currently-developing {
  background: rgba(242, 146, 0, 0.1);
  border-radius: 1000px;
  color: #f29200;
  padding: 1px 12px;
  line-height: 2;
  float: left;
  font-size: 12px;
}

.known-as:after {
  clear: both;
  height: 0;
  width: 100%;
  content: "";
  display: block;
}

.expert-in:after {
  clear: both;
  height: 0;
  width: 100%;
  content: "";
  display: block;
}

.currently-developing:after {
  clear: both;
  height: 0;
  width: 100%;
  content: "";
  display: block;
}

.icon-bg {
  background-color: #fba62742;
}

.opacity {
  opacity: 0.075;
}

.profile__card__balance {
  display: flex;
  flex-direction: row;
  margin-bottom: 2rem;
  justify-content: space-between;
  gap: 1rem;
  width: fit-content;

  &__item {
    display: flex;
    align-items: center;
    border: 1px solid #f2f2f2;
    padding: 0rem 0rem;
    width: 100%;
    overflow: hidden;
    border-radius: 1rem;

    img {
      width: 4.5rem;
      height: auto;
      padding: 1rem 1rem;
      border-right: 1px solid #f2f2f2;
    }

    h6 {
      color: #000;
      text-align: center;
      font-size: 1.3rem;
      font-weight: 600;
      padding: 1rem 1rem;
    }
  }
}
</style>
